import { useContext } from "react";
import Tooltip from "@mui/material/Tooltip";

import { ClinicaContext } from "../../context/clinica-context";
import "./BadgeUnidade.scss";

/**
 * Sigla da unidade onde um registo foi criado.
 *
 * Não se renderiza nas clínicas de unidade única: aí todos os registos seriam
 * da mesma unidade e a pastilha seria só ruído. Também não aparece em registos
 * anteriores à divisão, que não têm unidade atribuída.
 *
 * A verificação do `multiEstabelecimento` fica aqui dentro de propósito — assim
 * quem usa o componente só tem de lhe passar o estabelecimento.
 */
const BadgeUnidade = ({ estabelecimento, prefixo = "Criado em" }) => {
  const clinica = useContext(ClinicaContext);

  if (!clinica?.clinica?.multiEstabelecimento) return null;
  if (!estabelecimento?.codigo) return null;

  return (
    <Tooltip title={`${prefixo} ${estabelecimento.nome}`}>
      <span className="badge-unidade">{estabelecimento.codigo}</span>
    </Tooltip>
  );
};

export default BadgeUnidade;
